<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card>
            <!-- <v-card-title class="headline">
              {{ $t('custom.teletype_messages') }}
            </v-card-title> -->
            <v-card-text>
              <teletype-chat ref="teletypeChat" />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import TeletypeChat from '@/components/dashboard/clients/TeletypeChat.vue';

export default {
  components: {
    TeletypeChat
  },
  data() {
    return {};
  },
  created() {
    this.setTitle();
    // FT-066: orphan-sweep удалён — per-instance auto-unsubscribe (CableSubscriber mixin в
    // TeletypeChat/TeletypeClient) сам снимает TeletypeDialog в beforeDestroy. Ручной скан
    // подписок по имени канала больше не нужен (held-ref модель).
  },
  mounted() {
    // При монтировании страницы также сбрасываем активный диалог
    if (this.$refs.teletypeChat) {
      this.$refs.teletypeChat.resetActiveDialog();
    }
  },
  methods: {
    setTitle() {
      document.title = this.$t('teletype.teletype_messages') + ' | ' + this.$t('custom.app_name');
    }
  }
};
</script>

<style scoped>
/* Дополнительные стили для страницы */
</style>
